import script from "./EntiyInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EntiyInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./EntiyInfoView.vue?vue&type=style&index=0&id=452f88b3&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452f88b3"]])

export default __exports__